import { Button } from 'canoe';
import React from 'react';

export const VariableHelp = () => {
  const showHelpModal = () =>
    window.Candu?.triggerModal({ slug: 'generate-dynamic-urls-with-user-traits-modal' });

  return (
    <Button appearance="text" variant="secondary" size="xsmall" mb="xs" onClick={showHelpModal}>
      Generate Dynamic URLs with Variables
    </Button>
  );
};
